import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Guardas
import { AuthGuard } from '@app/guards/auth.guard';

// Componentes
import { ResumoFinanceiroComponent } from '@app/pages/financeiro/financeiro-resumo/resumo-financeiro.component';
import { ReceberListaComponent } from '@app/pages/financeiro/receber/receber-lista/receber-lista.component';
import { ReceberFormComponent } from '@app/pages/financeiro/receber/receber-form/receber-form.component';
import { PagarListaComponent } from '@app/pages/financeiro/pagar/pagar-lista/pagar-lista.component';
import { PagarFormComponent } from '@app/pages/financeiro/pagar/pagar-form/pagar-form.component';
import { LancamentoListaComponent } from '@app/pages/financeiro/lancamento/lancamento-lista/lancamento-lista.component';
import { LancamentoFormComponent } from '@app/pages/financeiro/lancamento/lancamento-form/lancamento-form.component';
import { ListaChequeComponent } from '@app/pages/financeiro/lista-cheque/lista-cheque.component';
//import { FinanceiroProcessoComponent } from '@app/pages/financeiro/financeiro-processo/financeiro-processo/financeiro-processo.component';
//import { FinanceiroProcessoRelatorioComponent } from '@app/pages/financeiro/financeiro-processo/financeiro-processo-relatorio/financeiroProcessoRelatorio.component';
//import { RelPrestacaoContasComponent } from '@app/pages/financeiro/financeiro-processo/relatorio-prestacao-contas/relatorio-prestacao-contas.component';
import { TransferenciaFormComponent } from '@app/pages/financeiro/lancamento/transferencia-form/transferencia-form.component';
//import { FinanceiroProcessoFormComponent } from '@app/pages/financeiro/financeiro-processo/financeiro-processo-form/financeiro-processo-form.component';
//import { TutelaProvisoriaFormComponent } from '@app/pages/financeiro/financeiro-processo/tutela-provisoria-form/tutela-provisoria-form.component';
// import { BaixaValorComponent } from '@app/pages/financeiro/baixa/baixa-valor/baixa-valor.component';
// import { BaixaFormasComponent } from '@app/pages/financeiro/baixa/baixa-formas/baixa-formas.component';
import { BaixaComponent } from '@app/pages/financeiro/baixa/baixa.component';
import { NotaFiscalListaComponent } from "@app/pages/financeiro/nota-fiscal/nota-fiscal-lista/nota-fiscal-lista.component";
import { NotaFiscalFormComponent } from './nota-fiscal/nota-fiscal-form/nota-fiscal-form.component';
import { DivisaoHonorariosListaComponent } from './divisao-honorarios/divisao-honorarios-lista/divisao-honorarios-lista.component';
import { DivisaoHonorariosDetalharComponent } from './divisao-honorarios/divisao-honorarios-detalhar/divisao-honorarios-detalhar.component';
import { DivisaoHonorariosVincularComponent } from './divisao-honorarios/divisao-honorarios-vincular/divisao-honorarios-vincular.component';
import { RateioFormComponent } from './pagar/rateio-form/rateio-form.component';

const financeiroRoutes: Routes = [
  { path: 'resumo-financeiro', component: ResumoFinanceiroComponent, canActivate: [AuthGuard] },
  { path: 'baixa/:tipo/:id/:processoId', component: BaixaComponent, canActivate: [AuthGuard] },
  { path: 'baixa/:tipo/:id', component: BaixaComponent, canActivate: [AuthGuard] },

  { path: 'receber', component: ReceberListaComponent, canActivate: [AuthGuard] },
  { path: 'receber/novo', component: ReceberFormComponent, canActivate: [AuthGuard] },
  { path: 'receber/novo/processo/:processoid', component: ReceberFormComponent, canActivate: [AuthGuard] },
  { path: 'receber/editar/:id', component: ReceberFormComponent, canActivate: [AuthGuard] },

  { path: 'pagar', component: PagarListaComponent, canActivate: [AuthGuard] },
  { path: 'pagar/novo', component: PagarFormComponent, canActivate: [AuthGuard] },
  { path: 'pagar/novo/processo/:processoid', component: PagarFormComponent, canActivate: [AuthGuard] },
  { path: 'pagar/editar/:id', component: PagarFormComponent, canActivate: [AuthGuard] },
  { path: 'rateio/novo', component: RateioFormComponent, canActivate: [AuthGuard] },

  {path: 'divisaoHonorarios', component: DivisaoHonorariosListaComponent, canActivate: [AuthGuard]},
  {path: 'divisaoHonorarios/detalharDivisao/:id', component: DivisaoHonorariosDetalharComponent, canActivate: [AuthGuard]},
  {path: 'divisaoHonorarios/vincular', component: DivisaoHonorariosVincularComponent, canActivate: [AuthGuard]},
  
  { path: 'lancamento', component: LancamentoListaComponent, canActivate: [AuthGuard] },
  { path: 'lancamento/novo', component: LancamentoFormComponent, canActivate: [AuthGuard] },
  { path: 'lancamento/transferencia', component: TransferenciaFormComponent, canActivate: [AuthGuard] },
  { path: 'lancamento/editar/:id', component: LancamentoFormComponent, canActivate: [AuthGuard] },
  { path: 'lancamento/:contaid/:data', component: LancamentoListaComponent, canActivate: [AuthGuard] },

  { path: 'lista-cheque', component: ListaChequeComponent, canActivate: [AuthGuard] },

  { path: 'nota-fiscal', component: NotaFiscalListaComponent, canActivate: [AuthGuard] },
  { path: 'nota-fiscal/novo', component: NotaFiscalFormComponent, canActivate: [AuthGuard] },
  { path: 'nota-fiscal/novo/:id/:processoId', component: NotaFiscalFormComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(financeiroRoutes)],
  exports: [RouterModule]
})
export class FinanceiroRoutingModule { }
